import { HorizontalNavbarHeight } from '@atomic/obj.constants';
import styled from 'styled-components';
export const SidebarPageWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - ${HorizontalNavbarHeight}px);
`;
